// extracted by mini-css-extract-plugin
export default {"title":"aRMsH","text":"J7owD","tariffs":"KiJoj"};